import { useApi } from './use-api-call';

export const useSearchPageApi = () =>
    useApi<{
        pages: PageDTO[];
        allowEdit: boolean;
    }>('/page/search-page');

export const useGetPageApi = () =>
    useApi<{ page: PageDTO; allowEdit: boolean }>('/page/get-page/{id}');

export const useSavePageApi = () => useApi<{ page: PageDTO }>('/page/save-page');

export const useDeletePageApi = () => useApi('/page/delete-page/{id}');

export interface ContentDTO {
    title: string;
    sections: {
        heading: string;
        content: string[];
    }[];
}

export interface PageDTO {
    id?: string;
    title: string;
    createdAt?: Date;
    createdBy?: string;
    modifiedAt?: Date;
    modifiedBy?: string;
}
